import { scrollToStep } from "./scrollToStep";

export const scrollToId = (id: string): void => {
    const element = document.getElementById(id);
    scrollToStep(element);
};
